










// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/profilExclusion/edit/EditCodic.vue'
import CheckState from '@/components/shared/CheckState.vue'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'
import { TypeOffre } from '@/enum/TypeOffre'

@Component({
  name: 'ReadCodic',    
  components:{CheckState,Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    profilExclusion:{
      type:Object,
      default:getDefaultAloProfilExclusion()
    },
    editable:{
      type:Boolean,
      default:true
    },
  }
})
export default class ReadCodic extends Vue {
  
  private profilExclusion!:AloProfilExclusion
  private loading!:boolean

  edit() { 
    (this.$refs.edit as Edit).edit(this.profilExclusion)
  }

}
